<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/home'}">会议学术平台</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; Coded with
        <i class="fa fa-heart heart"></i> by
        <a href="https://binarcode.com" target="_blank">BinarCode</a>.
        Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    name: 'content-footer',
    data(){
      return {

      }
    }
  }

</script>
<style scoped>
.footer{
  width: 100%;
  /* width: calc(100% - 260px); */
  /* position:fixed;
  bottom: 0; */
  background-color: black;
}
</style>>


